import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  activityTypes as types,
  LoadActivityAction,
  LoadActivityAsExcelAction, LoadActivityAsExcelFailsAction,
  LoadActivityAsExcelSuccessAction,
  LoadActivityFailsAction,
  LoadActivitySuccessAction
} from './activity.actions';
import { catchError, map, tap, concatMap, mergeMap } from 'rxjs/operators';
import {
  ActivityReportRequest, ActivityReport
} from '../shared/models';
import { ActivityService } from '../shared/services/activity.service';
import { BlobWithFilename } from '../../../shared';
import * as FileSaver from 'file-saver-es';

@Injectable()
export class ActivityEffects {

  constructor(private actions$: Actions,
    private activityService: ActivityService) { }

  loadActivity$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(types.LOAD_ACTIVITY),
      map(action => (action as LoadActivityAction).payload),
      concatMap((request: ActivityReportRequest) =>
        this.activityService.getActivities(request)
          .pipe(
            map((response: ActivityReport) => new LoadActivitySuccessAction(response)),
            catchError((error) => of(new LoadActivityFailsAction(error)))
          )
      )
    );
  });

  loadActivityAsExcel$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(types.LOAD_ACTIVITY_AS_EXCEL),
      map(action => (action as LoadActivityAsExcelAction).payload),
      mergeMap((request: ActivityReportRequest) =>
        this.activityService.getActivitiesAsExcel(request)
          .pipe(
            map((response: BlobWithFilename) => new LoadActivityAsExcelSuccessAction(response)),
            catchError((error) => of(new LoadActivityAsExcelFailsAction(error)))
          )
      )
    );
  });

  loadActivityAsExcelSuccess$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(types.LOAD_ACTIVITY_AS_EXCEL_SUCCESS),
      map(action => (action as LoadActivityAsExcelSuccessAction).payload),
      tap((pdf: BlobWithFilename) => { FileSaver.saveAs(pdf, pdf.filename); })
    );
  });
}
